import { RequestTypeDesc } from "../types/RequestType";

export default {
  PERSONAL: "personal" as RequestTypeDesc,
  PERSONAL_ID: 1,
  BUSINESS: "business" as RequestTypeDesc,
  BUSINESS_ID: 2,
  UNLIMITED: "",
};
